// extracted by mini-css-extract-plugin
export default {"DiffPlaceholderSVG":"DiffPlaceholder-module__DiffPlaceholderSVG--LNh5I"};